import { createContext } from 'react';

import Key from '~interfaces/key';

export interface KeyContextValue {
	key: Key | undefined;
	overwrittenClientId: string | undefined;
}

const KeyContext = createContext<KeyContextValue>({
	key: undefined,
	overwrittenClientId: undefined,
});

export default KeyContext;
